import React, { useState, useEffect } from 'react';
import '../styles/Navigation.scss';
import logoWhite from '../images/logo_white-01.svg';
import { Link, useLocation } from 'react-router-dom';
import { useJoinModal } from './JoinModalProvider';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const Navigation = () => {
  const location = useLocation();
  const { pathname } = location;
  const { openModal } = useJoinModal();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Helper function to check if current path matches the given path
  const isActive = (path) => {
    if (path === '/') {
      return pathname === '/';
    }
    return pathname.startsWith(path);
  };

  // Handle window resize
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkIsMobile();
    
    // Set up listener
    window.addEventListener('resize', checkIsMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleJoinClick = () => {
    openModal();
  };

  return (
    <nav className="navigation">
      <div className="navigation__container">
        <div className="navigation__left">
          <Link to="/" className={`${isActive('/') ? 'active' : ''}`}>
            <img src={logoWhite} alt="FirstWhistle Logo" className="navigation__logo" />
          </Link>
          <div className="navigation__seo-text">
            AI-powered football team management for grassroots sports
          </div>
        </div>
        
        {!isMobile && (
          <div className="navigation__links">
            <Link to="/players" className={`navigation__link ${isActive('/players') ? 'active' : ''}`}>Players</Link>
            <Link to="/coaches" className={`navigation__link ${isActive('/coaches') ? 'active' : ''}`}>Coaches</Link>
            <Link to="/parents" className={`navigation__link ${isActive('/parents') ? 'active' : ''}`}>Parents</Link>
            <Link to="/about" className={`navigation__link ${isActive('/about') ? 'active' : ''}`}>About</Link>
            <Link to="/contact" className={`navigation__link ${isActive('/contact') ? 'active' : ''}`}>Contact</Link>
            <a href="https://my.FirstWhistle.app" target="_blank" rel="noopener noreferrer" className="navigation__login-button">Log In</a>
            <button className="navigation__join-button" onClick={handleJoinClick}>Join Now</button>
          </div>
        )}
        
        {isMobile && (
          <div className="navigation__mobile-menu-icon" onClick={toggleMenu}>
            <MenuIcon />
          </div>
        )}
      </div>
      
      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu__content">
          <div className="mobile-menu__header">
            <Link to="/" className="mobile-menu__logo-container">
              <img src={logoWhite} alt="FirstWhistle Logo" className="mobile-menu__logo" />
            </Link>
            <div className="mobile-menu__close-icon" onClick={toggleMenu}>
              <CloseIcon />
            </div>
          </div>
          <div className="mobile-menu__links">
            <Link to="/players" className={`mobile-menu__link ${isActive('/players') ? 'active' : ''}`}>Players</Link>
            <Link to="/coaches" className={`mobile-menu__link ${isActive('/coaches') ? 'active' : ''}`}>Coaches</Link>
            <Link to="/parents" className={`mobile-menu__link ${isActive('/parents') ? 'active' : ''}`}>Parents</Link>
            <Link to="/about" className={`mobile-menu__link ${isActive('/about') ? 'active' : ''}`}>About</Link>
            <Link to="/contact" className={`mobile-menu__link ${isActive('/contact') ? 'active' : ''}`}>Contact</Link>
          </div>
          <a href="https://my.FirstWhistle.app" target="_blank" rel="noopener noreferrer" className="mobile-menu__login-button">Log In</a>
          <button className="mobile-menu__join-button" onClick={handleJoinClick}>Join Now</button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation; 